<template>
  <!-- Control-level gate: when every configured action is unreachable the
       whole panel renders nothing (a CTA panel with no CTAs is dead weight);
       the editor always shows it. -->
  <div v-if="editMode || actions.length" class="v3-widget v3-panel v3-panel-pad" v-testid="testid">
    <div class="v3-panel-head" style="padding: 0 0 8px"><h3 v-testid="testid + '-title'">{{ title }}</h3></div>
    <p v-if="body" class="v3-body-text">{{ body }}</p>
    <div v-if="layout === 'tiles'" class="v3-tiles">
      <button v-for="(a, i) in actions" :key="'act' + i" class="v3-tile" type="button" v-testid="testid + '-row-' + (a.destination || a.label)" @click="go(a)">
        <span class="v3-tile-ic" :class="`v3-tile-ic--${toneFor(a, i)}`"><span class="ms">{{ a.icon || 'add' }}</span></span>
        <span class="v3-tile-label">{{ a.label }}</span>
        <span v-if="a.sub" class="v3-tile-sub">{{ a.sub }}</span>
      </button>
    </div>
    <div v-else class="v3-actions-row">
      <button v-for="(a, i) in actions" :key="'act' + i" class="v3-tt-btn" type="button" v-testid="testid + '-row-' + (a.destination || a.label)" @click="go(a)">{{ a.label }}</button>
    </div>
  </div>
</template>

<script>
import { canNavigateTo } from "@/composables/useV3Nav";

// New-portal (v3) ActionPanel — a "start something" CTA panel (prototype
// V3QuickStart / V3StartEval / V3StartGroup): heading + body + actions as a
// button row (default) or icon tiles with a detail line (`layout: 'tiles'` —
// the prototype's "Start something" StartGroup card). Pure presentation.
// Sibling: rm-portal-beta ActionPanelWidget.vue.
export default {
  name: "cLandingV3ActionPanel",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3ActionPanel";
    },
    title() {
      return this.definition.title || "Start levelling";
    },
    body() {
      return this.definition.body || "";
    },
    layout() {
      return this.definition.layout === "tiles" ? "tiles" : "buttons";
    },
    // Legacy-landing-config parity: only surface actions the user can reach
    // ('create' is gated on create options); the editor shows everything.
    actions() {
      const all = Array.isArray(this.definition.actions) ? this.definition.actions : [];
      if (this.editMode) return all;
      return all.filter((a) => !a.destination || canNavigateTo(this, a.destination));
    },
  },
  methods: {
    // Per-action tile-icon tone, falling back to the prototype cycle when unset.
    toneFor(a, i) {
      const cycle = ["accent", "violet", "green"];
      return (a && a.tone) || cycle[i % cycle.length];
    },
    go(a) {
      if (this.editMode) return;
      const dest = a.destination;
      if (!dest) return;
      if (dest === "create") {
        this.$emit("addDocument", "");
        return;
      }
      if (/^https?:\/\//i.test(dest)) {
        window.open(dest, "_blank");
        return;
      }
      this.$router.push({ name: dest }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
